<div class="two-columns">
    <div
        class="two-columns__inner{{align ? ' -align-' + align : ''}}{{adjust ? ' -adjust-'+adjust : ''}}{{alignVertical ? ' -align-vertical-'+alignVertical : ''}}">

        <div class="two-columns__col -left{{marginBottom ? ' -margin-bottom-'+marginBottom : ''}}{{align ? ' -align-' + align : ''}}"
            [ngClass]="{'-no-max-width': maxWidth === false, '-mobile-hide': mobileLeft === false}" *ngIf="left">
            <ng-container
                *ngTemplateOutlet="mobileLeft === false ? ((device$ | async) === 1 ? null : left) : left || null">
            </ng-container>
        </div>


        <div class="two-columns__col -right{{marginBottom ? ' -margin-bottom-'+marginBottom : ''}}{{align ? ' -align-' + align : ''}}"
            [ngClass]="{'-no-max-width': maxWidth === false, '-mobile-hide': mobileRight === false}" *ngIf="right">
            <ng-container
                *ngTemplateOutlet="mobileRight === false ? ((device$ | async) === 1 ? null : right) : right || null">
            </ng-container>
        </div>

    </div>
</div>